import React, { Component } from 'react'
import { getCustomWagersByWagerId } from '../../api-calls/customWagers';
import { Icon, Tooltip, message } from 'antd';
import { ethMultiplier } from '../../constants';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export default class JudgementCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cardContent: <Icon type="loading" />
        };
    }
    componentDidMount() {
        let self = this;
        getCustomWagersByWagerId(this.props.wagerId).then((response) => {
            self.setState({ toolTipMessage: response.bytes32Id });
            self.setState({
                thisBet: response, cardContent: <div className="custom-bets-page-cards-judge">
                    <span style={{ fontSize: "14pt", color: 'rgba(255,255,255,0.6)' }}>BET ID:
                 <CopyToClipboard text={response.bytes32Id} onCopy={() => message.info("Copied to clipboard!")}>
                            <Tooltip placement="bottom" title={self.state.toolTipMessage}>
                                <div className="custom-bet-modal-finalize-betId">{response.bytes32Id.slice(0, 7) + " ... " + response.bytes32Id.slice(62, 70)}</div>
                            </Tooltip>
                        </CopyToClipboard></span>
                    <br />
                    <span style={{ fontSize: "14pt", color: 'rgba(255,255,255,0.6)' }}>ETH EARNED:</span>  <span style={{ fontSize: "14pt", color: '#27f727' }}>{(((response.value + (response.odds > 99 ?
                        response.value / (response.odds / 100)
                        :
                        response.value * Math.floor(100 / response.odds))) / 100) / ethMultiplier).toFixed(4)

                    }</span>
                </div>
            });
        })
    }
    render() {
        return (
            <div>
                {this.state.cardContent}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/layoutComponents/JudgementCard.js